const setNavBg = () => {
    if (window.global.width >= 992) {
        if (window.pageYOffset > 50) {
            $('#nav').removeClass('bg-md-white--80').addClass('bg-md-white').data('toggleClassesDisabled', true);
        } else {
            $('#nav').addClass('bg-md-white--80').removeClass('bg-md-white').prop('toggleClassesDisabled', false);
        }
    } else {
        $('#nav').removeClass('bg-md-white--80').addClass('bg-md-white');
    }
};

window.onscroll = setNavBg;

setNavBg();